import { AxiosResponse } from 'axios';
import { bexHttpClient } from '../../clients';

/**
 * Theme read access for the per-app theme PICKER. Themes are GLOBAL (authored
 * in the Admin Portal); here an app only lists them and selects one via
 * app.themeId. Backed by BeX Server (common Redis); BeX Server is sole writer.
 */
export interface Theme {
    themeId: string;
    name: string;
    description?: string;
    variables: Record<string, string>;
    active?: boolean;
}

class ThemeService {
    async listThemes(): Promise<AxiosResponse> {
        return bexHttpClient.get('/redis/themes');
    }

    async getTheme(themeId: string): Promise<AxiosResponse> {
        return bexHttpClient.get(`/redis/themes/${encodeURIComponent(themeId)}`);
    }
}

const themeService = new ThemeService();
export { themeService };
